import { render, staticRenderFns } from "./newaddOrEdit.vue?vue&type=template&id=0e3d1d0a&scoped=true&"
import script from "./newaddOrEdit.vue?vue&type=script&lang=js&"
export * from "./newaddOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./newaddOrEdit.vue?vue&type=style&index=0&id=0e3d1d0a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3d1d0a",
  null
  
)

export default component.exports